import { create } from 'zustand';
import { apiService } from '../services';

interface State {
    loading: boolean,
    createDownloadSuccess: boolean,
    createDownload: (downloadRequest: DonwloadRequest) => void,
    clearError: () => void;
}

export enum DownloadRequestType {
    ProgramDetails = 0,
}

export interface DonwloadRequest {
    paramsJSON: any;
    downloadRequestType: DownloadRequestType;
}

export const useDownloadStore = create<State>((set) => ({
    loading: false,
    createDownloadSuccess: false,
    createDownload: async (downloadRequest: DonwloadRequest) => {
        set(() => ({ loading: true }));
        try {
            set(() => ({ loading: true }));
            await apiService.post("downloadRequest/createNewDownloadRequest", downloadRequest);
            set(() => ({ createDownloadSuccess: true }));
            setTimeout(() => set(() => ({ createDownloadSuccess: false })), 0);
        } catch (error) {
            console.error(error);
        } finally {
            set(() => ({ loading: false }));
        }
    },
    clearError: () => {
        set(() => ({ loading: false }))
    }
}))